import Vuex from "vuex";
import axios from "axios";

const historicoAtendimentoStore = new Vuex.Store({
  state: {
    loading: false,
    historico: [],
    unidade: null
  },

  mutations: {
    SET_HISTORICO(state, historico) {
      state.historico = historico;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_UNIDADE(state, unidade) {
      state.unidade = unidade;
    }
  },

  actions: {
    async getHistorico({ commit }, { perPage, range, page, filtro }) {
      commit("SET_LOADING", true);
      try {
        const params = {
          perPage: perPage,
          range: range || null,
          page: page,
          status_id: filtro?.status_id || null,
          "filtros[unidade_id]": filtro?.unidade_id || null,
          "filtros[data_inicial]": filtro?.data_inicial || null,
          "filtros[data_final]": filtro?.data_final || null,
        };

        Object.keys(params).forEach((key) => params[key] === null && delete params[key]);

        const response = await axios.get("api/dashboard/agenda-ativa/historico", { params });

        commit("SET_HISTORICO", response.data.data);

        return response;
      } catch (error) {
        return error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async getExportHistorico({ }, { range, filtro }) {
      try {
        const params = {
          range: range || null,
          status_id: filtro?.status_id || null,
          "filtros[unidade_id]": filtro?.unidade_id || null,
          "filtros[data_inicial]": filtro?.data_inicial || null,
          "filtros[data_final]": filtro?.data_final || null,
        };

        Object.keys(params).forEach((key) => params[key] === null && delete params[key]);

        return await axios.get("api/dashboard/agendamentos/export", { params });
      } catch (error) {
        return error;
      }
    },
  }
});

export default historicoAtendimentoStore;
